import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, ShieldCheckIcon, ClockIcon, CheckCircleIcon, BadgeCheckIcon } from 'lucide-react';
export function Hero() {
  const trustSignals = ['FBI & State of Maryland Approved', 'CJIS Authorized Provider', 'Bonded & Certified'];
  return <section className="relative min-h-0 lg:min-h-screen flex items-center pt-24 lg:pt-20 overflow-hidden bg-white border-b border-slate-100" aria-label="Welcome to Ambient Fingerprinting" data-id="element-91">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-id="element-92">
        <img src="https://cdn.magicpatterns.com/uploads/wKPBimhZuiv9sZmv3uVXxw/ChatGPT_Image_Apr_7,_2026,_01_10_57_AM.png" alt="" className="absolute inset-0 w-full h-full object-cover object-center lg:object-center opacity-[0.25] lg:opacity-[0.35]" data-id="element-93" />
        {/* Soft Light Gradients */}
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/40 to-transparent lg:via-white/10" data-id="element-94" />
        <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-white/10" data-id="element-95" />
      </div>

      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-8 relative z-10 w-full py-12 lg:py-20" data-id="element-96">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center" data-id="element-97">
          {/* Left Content - Typography & CTAs */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="lg:col-span-7 text-[#1E1F55]" data-id="element-98">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold leading-[1.1] lg:leading-[1.05] mb-8 tracking-tight max-w-3xl text-slate-900" data-id="element-99">
              Columbia, Maryland's Premier <br className="hidden sm:block" data-id="element-100" />
              <span className="text-[#2B7A9E]" data-id="element-101">
                Live Scan Mobile Fingerprinting
              </span>
            </h1>

            <p className="text-xl sm:text-lg lg:text-xl text-slate-600 mb-12 lg:mb-16 leading-relaxed font-normal max-w-2xl" data-id="element-102">
              We travel to your office or facility for professional, secure
              fingerprinting. Group appointments of 5 or more welcome.
            </p>

            {/* Consolidated Trust Signals */}
            <div className="flex flex-col sm:flex-row flex-wrap gap-y-5 gap-x-10 mb-16 lg:mb-20 max-w-2xl" data-id="element-103">
              {trustSignals.map(signal => <div key={signal} className="flex items-center gap-4 text-base sm:text-base font-bold text-slate-900" data-id="element-104">
                  <CheckCircleIcon className="h-6 w-6 text-[#4AA6CF] flex-shrink-0" data-id="element-105" />
                  <span data-id="element-106">{signal}</span>
                </div>)}
            </div>

            <div className="flex flex-col sm:flex-row gap-6 items-start sm:items-center" data-id="element-107">
              <a href="#/booking" className="bg-[#4AA6CF] hover:bg-[#3b85a6] text-white px-12 py-5 rounded-full flex items-center justify-center gap-4 font-extrabold text-lg sm:text-base lg:text-lg transition-all shadow-2xl shadow-[#4AA6CF]/20 hover:shadow-[#4AA6CF]/40 w-full sm:w-auto" data-id="element-108">
                <span data-id="element-109">Book Appointment</span>
                <ArrowRightIcon className="h-5 w-5 text-white group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-110" />
              </a>
            </div>
          </motion.div>

          {/* Right Content - Fingerprint Visual (Hidden on mobile to save space) */}
          <div className="hidden lg:flex lg:col-span-5 relative h-[500px] items-center justify-end" data-id="element-111">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.4,
            duration: 0.8
          }} className="relative w-full max-w-md" data-id="element-112">
              {/* The fingerprint graphic is now the clean focal point */}
            </motion.div>
          </div>
        </div>
      </div>

      {/* Subtle Bottom Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gray-100 to-transparent" data-id="element-113" />
    </section>;
}